import { useState } from 'react';
import { BottomSheet } from './BottomSheet';
import { Save } from 'lucide-react';

const TEXT_POSITIONS = [
  { value: '0', label: 'Сверху' },
  { value: '1', label: 'Справа' },
  { value: '2', label: 'Снизу' },
  { value: '3', label: 'Слева' },
];

export function EditPPSheet({ objectNumber, textPosition, onClose, onSave, onBack }) {
  const [number, setNumber] = useState(objectNumber);
  const [position, setPosition] = useState(String(textPosition));

  return (
    <BottomSheet title="Редактировать ПС" onClose={onClose} open={true} onBack={onBack} modal={true}>
      <div className="flex flex-col gap-5">

        {/* Номер ПС */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-500">
            Номер ПС
          </label>
          <input
            type="text"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            className="w-full px-4 py-3 rounded-xl border border-gray-200 text-gray-900 text-base focus:outline-none focus:ring-2 focus:ring-blue-500 bg-gray-50"
            placeholder="Введите номер ПС"
          />
        </div>

        {/* Расположение номера */}
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-500">
            Расположение номера
          </label>
          <div className="grid grid-cols-2 gap-2">
            {TEXT_POSITIONS.map((pos) => (
              <button
                key={pos.value}
                onClick={() => setPosition(pos.value)}
                className={`
                  py-3 rounded-xl text-sm font-medium transition-colors
                  ${position === pos.value 
                    ? 'bg-blue-500 text-white' 
                    : 'bg-gray-100 text-gray-600'}
                `}
              >
                {pos.label}
              </button>
            ))}
          </div>
        </div>

        {/* Кнопка сохранить */}
        <button
          onClick={() => onSave(number, parseInt(position))}
          className="w-full flex items-center justify-center gap-2 py-4 bg-blue-500 text-white rounded-xl font-medium text-base active:scale-95 transition-transform"
        >
          <Save size={18} />
          Сохранить
        </button>

      </div>
    </BottomSheet>
  );
}